import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchServiceRequests(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/service-requests/kitchen-view', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteServiceRequest(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/service-requests/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
